import { Action } from 'redux';

import { ListResult } from '../../../ts/fetchers/ListResult';
import { ExplorableItemType } from '../../../ts/models/ContentType';
import { IContentInfo } from '../../../ts/models/IContentInfo';
import { IRange } from '../../../ts/models/IRange';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import {
  ResetContentBusyFetching,
  SpaceContentsMissingSliceRequest,
  SpaceContentsRequest,
  SpaceContentsRequestFailed,
  SpaceContentsRequestSucceeded,
  SpaceContentsSliceSucceeded,
  SpaceContentsUpdateOwners,
} from '../AppActionTypes';
import { isActionFactory } from '../isActionFactory';

export interface SpaceContentsRequestAction extends Action {}

export function requestSpaceContents(): SpaceContentsRequestAction {
  return {
    type: SpaceContentsRequest
  };
}

export const isSpaceContentsRequestAction = isActionFactory<SpaceContentsRequestAction>(SpaceContentsRequest);

//-------------------------

export interface SpaceContentsRequestSucceededAction extends Action {
  readonly content: ListResult<IContentInfo>;
}

export function spaceContentsRequestSucceeded(content: ListResult<IContentInfo>): SpaceContentsRequestSucceededAction {
  return {
    type: SpaceContentsRequestSucceeded,
    content
  };
}

export const isSpaceContentsRequestSucceededAction = isActionFactory<SpaceContentsRequestSucceededAction>(SpaceContentsRequestSucceeded);

//-------------------------

export interface SpaceContentsRequestFailedAction extends Action {}

export function spaceContentsRequestFailed(): SpaceContentsRequestFailedAction {
  return {
    type: SpaceContentsRequestFailed
  };
}

export const isSpaceContentsRequestFailedAction = isActionFactory<SpaceContentsRequestFailedAction>(SpaceContentsRequestFailed);

//-------------------------

export interface SpaceContentsMissingSliceRequestAction extends Action, IRange {}

// From start (inclusive) to end (exclusive)
export function requestSpaceContentsMissingSlice(start: number, end: number): SpaceContentsMissingSliceRequestAction {
  return {
    type: SpaceContentsMissingSliceRequest,
    start: start,
    end: end
  };
}

export const isSpaceContentsMissingSliceRequestAction = isActionFactory<SpaceContentsMissingSliceRequestAction>(SpaceContentsMissingSliceRequest);

//-------------------------

export interface SpaceContentsSliceSucceededAction extends Action {
  start: number;
  content: ListResult<IContentInfo>;
}

export function spaceContentsSliceSucceeded(start: number, content: ListResult<IContentInfo>): SpaceContentsSliceSucceededAction {
  return {
    type: SpaceContentsSliceSucceeded,
    start,
    content
  };
}

export const isSpaceContentsSliceSucceededAction = isActionFactory<SpaceContentsSliceSucceededAction>(SpaceContentsSliceSucceeded);

//-------------------------

export interface UpdateOwnerData {
  contentId: string;
  ownerId: string;
  contentType: ExplorableItemType;
}

export interface SpaceContentsUpdateOwnersAction extends Action {
  owners: _.Dictionary<IUser>;
  contents: UpdateOwnerData[];
}

export function spaceContentsUpdateOwners(owners: _.Dictionary<IUser>, contents: UpdateOwnerData[]): SpaceContentsUpdateOwnersAction {
  return {
    type: SpaceContentsUpdateOwners,
    owners,
    contents
  };
}

export const isSpaceContentsUpdateOwnersAction = isActionFactory<SpaceContentsUpdateOwnersAction>(SpaceContentsUpdateOwners);

//-------------------------

export interface ResetContentBusyFetchingAction extends Action {}

export function resetContentBusyFetching(): ResetContentBusyFetchingAction {
  return {
    type: ResetContentBusyFetching
  };
}

export const isResetContentBusyFetchingAction = isActionFactory<ResetContentBusyFetchingAction>(ResetContentBusyFetching);
